// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_nv-0";